import React, { useState } from 'react';
import { Popover } from '@mui/material';
import { Appointments } from '@devexpress/dx-react-scheduler';
import WorkScheduleRangesForm from 'components/AddWorkSchedule/WorkScheduleCalendar/WorkScheduleRangesForm/WorkScheduleRangesForm';
import { FormTypes } from 'enums';
import useWorkScheduleCalendarContext from 'components/AddWorkSchedule/WorkScheduleCalendar/context/useWorkScheduleCalendarContext';
import { FormPayload } from 'components/AddWorkSchedule/WorkScheduleCalendar/WorkScheduleRangesForm/interfaces';
import AppointmentContent from './AppointmentContent';

export default function Appointment({
  data,
  durationType,
}: Pick<Appointments.AppointmentContentProps, 'data' | 'durationType'>) {
  const [initData, setInitData] = useState(data);
  const { handleUpdateWorkSchedule, workSchedules, handleRemoveWorkSchedule } =
    useWorkScheduleCalendarContext();
  const [editAnchorEl, setEditAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClose = () => {
    setEditAnchorEl(null);
    handleUpdateWorkSchedule({ schedule: initData });
  };

  const onSubmit = ({ startDate, endDate }: FormPayload) => {
    handleUpdateWorkSchedule({
      schedule: { ...initData, startDate, endDate },
      triggerApiCall: true,
      onSuccess: () => {
        setEditAnchorEl(null);
        const newInitData = workSchedules.find(
          (schedule) => schedule.id === initData.id,
        );
        if (newInitData) {
          setInitData(newInitData);
        }
      },
    });
  };

  return (
    <>
      <AppointmentContent
        data={data}
        durationType={durationType}
        onClick={(event) => {
          event.stopPropagation();
          setEditAnchorEl(event.currentTarget);
        }}
      />
      <Popover
        sx={{ '& .MuiPaper-root': { width: '38rem' } }}
        open={!!editAnchorEl}
        anchorEl={editAnchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <WorkScheduleRangesForm
          handleCloseModal={handleClose}
          onSubmit={onSubmit}
          data={data}
          type={FormTypes.edit}
          onDelete={() => {
            handleRemoveWorkSchedule(initData.id);
            setEditAnchorEl(null);
          }}
        />
      </Popover>
    </>
  );
}
